import '@base_js/modules/jquery.module.js'
import '@node_modules/magnific-popup'

import {
  beforePophover,
  afterPophover,
} from '@base_js/utils'

const MagnificPopupDirective = {
  bind: function (el, binding, vnode) {
    el.addEventListener('click', function(e){
    	let $el = $(el)
      e.preventDefault();
      var opts = {
        type:'inline',
        removalDelay: 300,
        mainClass: 'my-mfp-zoom-in',
        midClick: true,
        closeMarkup: '<button type="button" class="mfp-close new-hf-icon new-hf-icon-close-l"></button>',
        callbacks: {
            open: function(item){
            },
            beforeOpen: function () {
              beforePophover();
            },
            afterClose: function () {
              afterPophover();
            }
        }
      };
      
      $el.magnificPopup(opts).magnificPopup('open');
    })
  },
  unbind: function(el, binding, vnode){
  	el.removeEventListener('click')
  }
};

export default MagnificPopupDirective;
